import { Fragment, useState, useCallback, useEffect, useRef } from 'react';
import { useEffectAfterInit } from '@entegral/helpers.react/hooks/effect-after-init';
import { SidebarLarge } from '../property-card/sidebar-large';
import { SidebarSmall } from '../property-card/sidebar-small';

export function Sidebar({
  isLoading,
  isNothing,
  highlightedProperties,
  viewportedProperties,
}) {
  let { limit, increaseLimit } = useLimit({ base: 20, items: viewportedProperties });
  let totalCount = highlightedProperties.length + viewportedProperties.length;
  let sidebarRef = useRef(null);

  useEffect(() => sidebarRef.current.scrollTo({ top: 0, behavior: 'smooth' }), [highlightedProperties]);

  return (
    <div className={`map-search__sidebar`} ref={sidebarRef}>
      {!isLoading && !isNothing && totalCount === 0 && (
        <div className={`map-search__nothing-in-viewport`}>No properties in viewport</div>
      )}

      <Properties
        highlighted={highlightedProperties}
        viewported={viewportedProperties}
        limit={limit}
      />

      {limit < totalCount && (
        <div
          className={`map-search__show-more button button_size_small`}
          onClick={increaseLimit}
        >
          Show more properties
        </div>
      )}
    </div>
  );
}

function Properties({ highlighted, viewported, limit }) {
  let renderedItems = [];

  let index = 0;

  for (let item of highlighted) {
    if (index >= limit) break;

    renderedItems.push(
      <Fragment key={index}>
        <Separator index={index} />
        <SidebarLarge {...item} />
      </Fragment>
    );

    index++;
  }

  for (let item of viewported) {
    if (index >= limit) break;

    renderedItems.push(
      <Fragment key={index}>
        <Separator index={index} />
        <SidebarSmall {...item} />
      </Fragment>
    );

    index++;
  }

  return renderedItems;
}

function Separator({ index }) {
  return index !== 0 && (<div className={`map-search__separator`}></div>);
}

function useLimit({ base = 20, increment = base, items }) {
  let [limit, setLimit] = useState(base);

  let increaseLimit = useCallback(() => setLimit(x => x + increment), []);

  useEffectAfterInit(() => setLimit(base), [items]);

  return { limit, increaseLimit };
}
